if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelector('.daki-product-image-nav')?.addEventListener('pointerup', event => event.stopPropagation());
        this.querySelectorAll('[data-image-step]').forEach(button => button.addEventListener('click', () => this.moveImage(Number(button.dataset.imageStep))));
        this.addEventListener('keydown', event => {
          if (window.innerWidth > 749 || !this.hasAttribute('open')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.moveImage(event.key === 'ArrowRight' ? 1 : -1); }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      imageItems() { return [...this.querySelectorAll('.product-media-modal__content > img[data-media-id]')]; }

      updateImageNavigation() {
        const images = this.imageItems();
        const nav = this.querySelector('.daki-product-image-nav');
        if (!nav) return;
        const index = images.findIndex(image => image.classList.contains('active'));
        nav.hidden = images.length < 2 || index < 0;
        nav.querySelector('[data-image-count]').textContent = (index + 1) + ' / ' + images.length;
      }

      moveImage(step) {
        const images = this.imageItems();
        if (images.length < 2) return;
        const current = images.findIndex(image => image.classList.contains('active'));
        const next = images[(Math.max(0, current) + step + images.length) % images.length];
        this.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach(media => media.classList.toggle('active', media === next));
        const container = this.querySelector('.product-media-modal__content');
        container.scrollTop = 0; container.scrollLeft = 0;
        this.updateImageNavigation();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        this.updateImageNavigation();
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

